var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"under"},[_c('HuliNavigationVue',{attrs:{"current-page":_vm.currentPage}}),_vm._m(0),_c('HuliIntro'),_c('HuliGallery'),_c('HuliOngoing'),_c('HuliFooter')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pic-bgc"},[_c('div',{staticClass:"top-pic",attrs:{"data-wow-duration":"1s"}},[_c('img',{attrs:{"src":require("../assets/info/banner.png")}})])])
}]

export { render, staticRenderFns }